export default __webpack_public_path__ + "static/media/mapear-brand.4c81ce9b.svg";